import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/dental/frontend/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/var/www/dental/frontend/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["CtaBand"] */ "/var/www/dental/frontend/src/components/marketing/CtaBand.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/dental/frontend/src/components/marketing/motion/Reveal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageHero"] */ "/var/www/dental/frontend/src/components/marketing/PageHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlatformMock"] */ "/var/www/dental/frontend/src/components/marketing/platform/PlatformMock.tsx");
